import { logE } from "@blacknut/logging/dist";
import { RedeemSubDetails } from "../../model";
import apiService, { TAG } from "../ApiService";

export declare type VerifyRedeemCodeOpt = {
  redemptionCode?: string;
  organization: string;
  sessionId?: string;
};

export const verifyRedeemCode = ({
  redemptionCode,
  organization,
  sessionId,
}: VerifyRedeemCodeOpt) => {
  if (typeof organization !== "string") {
    logE(TAG, "Caught error verifying redeem code : organization must be a string");
    // Don't throw an error because API monitoring is better
  }

  return apiService.get<RedeemSubDetails | Record<string, never>>({
    path: `public/partner/verify`,
    params: {
      redemptionCode,
      organization,
      sessionId,
    },
    crm: true,
  });
};
